var _rect, _rect2, _rect3, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 10,
    fill: "#FF671F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 39,
    height: 10,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 39,
    height: 10,
    fill: "#046A38"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15,
    r: 4.75,
    fill: "white",
    stroke: "#06038D",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10L20.2493 13.1065L21.2941 10.1704L20.7309 13.2355L22.5 10.6699L21.1626 13.4848L23.5355 11.4645L21.5152 13.8374L24.3301 12.5L21.7645 14.2691L24.8296 13.7059L21.8935 14.7507L25 15L21.8935 15.2493L24.8296 16.2941L21.7645 15.7309L24.3301 17.5L21.5152 16.1626L23.5355 18.5355L21.1626 16.5152L22.5 19.3301L20.7309 16.7645L21.2941 19.8296L20.2493 16.8935L20 20L19.7507 16.8935L18.7059 19.8296L19.2691 16.7645L17.5 19.3301L18.8374 16.5152L16.4645 18.5355L18.4848 16.1626L15.6699 17.5L18.2355 15.7309L15.1704 16.2941L18.1065 15.2493L15 15L18.1065 14.7507L15.1704 13.7059L18.2355 14.2691L15.6699 12.5L18.4848 13.8374L16.4645 11.4645L18.8374 13.4848L17.5 10.6699L19.2691 13.2355L18.7059 10.1704L19.7507 13.1065L20 10Z",
    fill: "#06038D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.afec15f0f335cae63de559248dbdd533.svg";
export { ForwardRef as ReactComponent };